import {animate,stagger} from 'animejs';

window.anime = {};
window.anime.animate = animate;
window.anime.stagger = stagger;